import React, { useState } from "react";
import "../Aboutus/Aboutme.css";

const AboutMe = () => {
  const [isVideoOpen, setVideoOpen] = useState(false);

  const toggleVideo = () => {
    setVideoOpen(!isVideoOpen);
  };

  return (
    <section className="about-us-m">
     
      <div className="content-m">
        {/* Left Div */}
        <div className="left-div-m">
          <p className="description-m">WHO WE ARE</p>
          <h1 className="subheading-m">
            Crafting Unforgettable Events with Precision & Passion
          </h1>
          <div className="image-wrapper-m">
            <img
              src="/abme2.jpeg"
              alt="Shree Ver Event"
              loading="lazy"
              className="image-m"
            />
            <div className="play-button-m" onClick={toggleVideo}>
              ▶
            </div>
          </div>
        </div>

        {/* Right Div */}
        <div className="right-div-m">
          <img
            src="/abme.jpg"
            alt="Conference Event"
            loading="lazy"
            className="image-right-m"
          />
           <h1 className="heading-m">About <span className="heading-m-span">Us</span></h1>
      <hr className="red-line-m" />
          <p className="additional-text-m">
            At <strong>श्री Var Event & Conference</strong>, we believe that every event is a story waiting to be told. From grand weddings and corporate conferences to social celebrations and brand activations, our expert team turns your vision into a seamless, memorable experience. With a sharp eye for detail and a passion for perfection, we manage everything — from planning and decor to logistics and execution. Your event is not just an occasion; it’s our commitment.
          </p>
        </div>
      </div>

      {/* Video Overlay */}
      {isVideoOpen && (
        <div className="video-overlay-m">
          <div className="video-content-m">
            <span className="close-button-m" onClick={toggleVideo}>
              ✖
            </span>
            <video className="video-sec" controls>
              <source src="/abme.MP4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutMe;
